class WishlistAcceptRequests extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.acceptRequests = this.acceptRequests.bind(this)
    this.listeners.add(this, 'click', this.acceptRequests)
  }

  async acceptRequests (e) {
    e.preventDefault()

    await window.BAO.wishlist.acceptRequests(this.listId, this.token)

    window.location.reload()
  }

  get listId () {
    return this.dataset.listId
  }

  get token () {
    return window.BAO.wishlist.token
  }
}

customElements.define('wishlist-accept-requests', WishlistAcceptRequests)
